import React from 'react';

export const connect = (api) => (component, mapStateToProps, opts = {}) => {
  const namespace = (typeof mapStateToProps === 'string') ? mapStateToProps : null;
  const WrappedElement = React.createClass({
    mapStateToProps() {
      if (mapStateToProps) {
        const type = typeof mapStateToProps;
        if (type !== 'function' && type !== 'string') {
          throw new TypeError('Expected mapStateToProps to be function or string.');
        }
        if (namespace) {
          mapStateToProps = (state) => state[namespace];
        }
        return mapStateToProps(api.getState());
      }
      return {};
    },
    componentWillMount() {
      this.unsubscribe = api.subscribe(() => {
        if (this._isMounted) {
          const state = api.getState();
          this.setState(state);
        }
      });
    },
    componentDidMount() {
      this._isMounted = true;
    },
    componentWillUnmount() {
      this._isMounted = false;
      this.unsubscribe();
      if (!opts.noClearOnUnmount) {
        if (namespace && namespace !== 'routing' && namespace !== 'overview' && namespace !== 'management') { // HACK FOR LINKS
          api.store.dispatch({type: '__INIT@' + namespace});
        }
      }
    },
    render() {
      const props = {...this.props, ...this.mapStateToProps(), api};
      return React.createElement(component, props);
    },
  });
  WrappedElement.displayName = `REX_CONNECT(${component.displayName || component.name || 'Component'})`;
  return WrappedElement;
};



// WEBPACK FOOTER //
// ../rex/lib/react-rex.js